import { useState } from 'react';
import SectionHeading from './SectionHeading';
import { threadItems } from '@/mocks/home';

const quickReactions = ['蹲后续', '真的假的', '已核实', '等反转', '有点意思'];

export default function DiscussionZone() {
  const [draft, setDraft] = useState('');
  const [activeReaction, setActiveReaction] = useState('蹲后续');

  return (
    <section id="discuss" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-shell px-4 md:px-6">
        <SectionHeading
          eyebrow="COMMUNITY TALK"
          title="热评广场"
          desc="这里比正文热闹。评论区的补充、纠正和脑洞，往往才是真正让人停不下来的部分。"
          action={{ label: '围观全部讨论', href: '#discuss' }}
        />

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-[minmax(0,1fr)_340px] lg:gap-8">
          <div className="flex flex-col gap-4">
            {threadItems.map((thread) => (
              <article key={thread.id} className="rounded-lg border border-background-200/80 bg-background-50 p-4 md:p-5">
                <div className="flex items-start gap-3">
                  <span className="h-11 w-11 shrink-0 overflow-hidden rounded-full bg-background-200">
                    <img
                      src={thread.avatar}
                      alt={thread.author}
                      title={`${thread.author} - 免费看料讨论区`}
                      className="h-full w-full object-cover object-top"
                    />
                  </span>
                  <div className="min-w-0 flex-1">
                    <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
                      <span className="text-sm font-medium text-foreground-950">{thread.author}</span>
                      <span className="rounded-sm bg-accent-100 px-1.5 py-0.5 text-[10px] text-accent-900">{thread.role}</span>
                      <span className="text-[11px] text-foreground-400">{thread.time}</span>
                    </div>
                    <div className="mt-1 flex items-center gap-1 text-[11px] text-foreground-500">
                      参与了话题
                      <a href="#topics" className="text-primary-600 hover:text-primary-700 cursor-pointer">
                        #{thread.topic}
                      </a>
                    </div>
                    <p className="mt-3 text-sm leading-relaxed text-foreground-800">{thread.content}</p>
                  </div>
                </div>

                <div className="mt-4 rounded-md border-l-2 border-secondary-300 bg-secondary-50/70 px-4 py-3">
                  <p className="text-xs leading-relaxed text-secondary-900">{thread.repliesPreview}</p>
                  <span className="mt-1 block text-[11px] text-secondary-700">还有 {thread.replies} 条回复</span>
                </div>

                <div className="mt-4 flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-foreground-500">
                  <button type="button" className="flex items-center gap-1.5 transition-colors hover:text-primary-600 cursor-pointer">
                    <i className="ri-thumb-up-line text-sm"></i>
                    {thread.likes}
                  </button>
                  <button type="button" className="flex items-center gap-1.5 transition-colors hover:text-primary-600 cursor-pointer">
                    <i className="ri-chat-3-line text-sm"></i>
                    {thread.replies}
                  </button>
                  <button type="button" className="flex items-center gap-1.5 transition-colors hover:text-primary-600 cursor-pointer">
                    <i className="ri-share-forward-line text-sm"></i>
                    转发
                  </button>
                  <span className="flex items-center gap-1.5">
                    <i className="ri-user-3-line text-sm"></i>
                    12 人正在浏览
                  </span>
                </div>
              </article>
            ))}
          </div>

          <aside className="flex flex-col gap-6">
            <div className="rounded-lg border border-background-200/80 bg-background-100/70 p-5">
              <h3 className="font-heading text-base font-bold text-foreground-950">说两句</h3>
              <p className="mt-1 text-xs text-foreground-500">理性讨论，先说事实再说观点。</p>
              <textarea
                value={draft}
                onChange={(e) => setDraft(e.target.value.slice(0, 500))}
                maxLength={500}
                rows={4}
                placeholder="这条料你怎么看？"
                className="mt-3 w-full resize-none rounded-md border border-background-300/70 bg-background-50 px-3 py-2.5 text-sm text-foreground-900 placeholder:text-foreground-400 focus:border-primary-400 focus:outline-none focus:ring-1 focus:ring-primary-400"
              />
              <div className="mt-2 flex flex-wrap gap-2">
                {quickReactions.map((r) => (
                  <button
                    key={r}
                    type="button"
                    onClick={() => setActiveReaction(r)}
                    className={`whitespace-nowrap rounded-full border px-3 py-1 text-xs transition-colors cursor-pointer ${
                      activeReaction === r
                        ? 'border-primary-400 bg-primary-100 text-primary-700'
                        : 'border-background-300/70 bg-background-50 text-foreground-600 hover:border-secondary-300 hover:text-secondary-800'
                    }`}
                  >
                    {r}
                  </button>
                ))}
              </div>
              <div className="mt-3 flex items-center justify-between text-[11px] text-foreground-400">
                <span>{draft.length}/500</span>
                <button
                  type="button"
                  className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-xs font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
                >
                  发布讨论
                </button>
              </div>
            </div>

            <div className="rounded-lg border border-background-200/80 bg-background-50 p-5">
              <h3 className="font-heading text-base font-bold text-foreground-950">现在在线</h3>
              <div className="mt-3 flex items-center gap-3">
                <div className="flex -space-x-2">
                  <span className="h-8 w-8 overflow-hidden rounded-full border-2 border-background-50 bg-background-200">
                    <img
                      src="https://readdy.ai/api/search-image?query=warm%20toned%20minimal%20avatar%20of%20young%20person%20with%20soft%20amber%20light%2C%20plain%20beige%20background%2C%20no%20text&width=80&height=80&seq=freekanliao-on-01&orientation=squarish"
                      alt="在线用户"
                      className="h-full w-full object-cover object-top"
                    />
                  </span>
                  <span className="h-8 w-8 overflow-hidden rounded-full border-2 border-background-50 bg-background-200">
                    <img
                      src="https://readdy.ai/api/search-image?query=warm%20toned%20minimal%20avatar%20of%20person%20with%20orange%20rim%20light%2C%20plain%20cream%20background%2C%20no%20text&width=80&height=80&seq=freekanliao-on-02&orientation=squarish"
                      alt="在线用户"
                      className="h-full w-full object-cover object-top"
                    />
                  </span>
                  <span className="h-8 w-8 overflow-hidden rounded-full border-2 border-background-50 bg-background-200">
                    <img
                      src="https://readdy.ai/api/search-image?query=warm%20toned%20minimal%20avatar%20of%20person%20with%20golden%20soft%20light%2C%20plain%20sand%20background%2C%20no%20text&width=80&height=80&seq=freekanliao-on-03&orientation=squarish"
                      alt="在线用户"
                      className="h-full w-full object-cover object-top"
                    />
                  </span>
                </div>
                <p className="text-xs text-foreground-600">
                  <span className="font-heading text-lg font-bold text-foreground-950">9.4万</span> 人在线蹲料
                </p>
              </div>
              <ul className="mt-4 flex flex-col gap-2 border-t border-background-200/70 pt-4 text-xs text-foreground-600">
                <li className="flex items-center gap-2">
                  <i className="ri-checkbox-circle-line text-secondary-500"></i>
                  首发线索标注来源与时间
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-checkbox-circle-line text-secondary-500"></i>
                  未核实内容会明确标注「待核实」
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-checkbox-circle-line text-secondary-500"></i>
                  评论区欢迎补充与纠正
                </li>
              </ul>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}